<!--
 * @Description: 
 * @Author: 樊文静
 * @LastEditors: Please set LastEditors
 * @Date: 2021-07-28 14:12:49
 * @LastEditTime: 2021-10-26 15:58:44
-->
<template>
  <div class="remind-set">
    <div class="edit-title clearfix">
      <span class="title"> {{ title }}</span
      ><span class="subtitle">{{ subtitle }}</span>
    </div>
    <div class="edit-content">
      <el-form :model="ruleSetting" ref="formBase" label-width="80px">
        <div
          class="set-content-wrap"
          v-for="(item, index) in ruleSetting.formData"
          :key="index"
        >
          <div class="rules-name">
            规则{{ index + 1
            }}<span
              v-if="index !== 0"
              class="delete e6-icon-clear_line"
              @click="deleteRuleItem(index)"
            ></span>
          </div>
          <el-row :gutter="20">
            <el-col class="col-item" :span="24">
              <div class="vertical-center">
                <span class="remind-title">提醒状态</span>
                <el-switch v-model="item.statusBoolean" active-color="#13ce66">
                </el-switch>
                <span class="after-switch">
                  {{ item.statusBoolean ? "开启" : "关闭" }}
                </span>
              </div>
            </el-col>
            <template v-if="item.statusBoolean">
              <el-col class="col-item" :span="24">
                <el-form-item label="提醒条件" class="form-item-list">
                  <div
                    v-for="(val, $i) in item.rules"
                    :key="$i"
                    class="rule-list"
                  >
                    <template v-if="item.rules.length">
                      <el-form-item
                        :prop="`formData.${index}.rules.${$i}.ruleCondition`"
                        :rules="{
                          required: true,
                          message: '请选择订单业务',
                          trigger: 'change'
                        }"
                      >
                        <vr-select
                          v-if="ruleType === '1'"
                          virtual
                          clearable
                          :is-title="true"
                          v-model="val.ruleCondition"
                          :data="contactData.ruleConditionList"
                        ></vr-select>
                        <vr-select
                          v-else
                          virtual
                          clearable
                          :is-title="true"
                          v-model="val.ruleCondition"
                          :data="contactData.ruleWaybillConditionList"
                        ></vr-select>
                      </el-form-item>
                      <el-form-item
                        :prop="`formData.${index}.rules.${$i}.ruleOperator`"
                        :rules="{
                          required: true,
                          message: '请选择条件',
                          trigger: 'change'
                        }"
                      >
                        <vr-select
                          class="comparison-operators"
                          ref="shippingAreaId"
                          virtual
                          clearable
                          :is-title="true"
                          :search="false"
                          v-model="val.ruleOperator"
                          :data="remindSetList"
                        ></vr-select>
                      </el-form-item>
                      <el-form-item
                        style="flex:1"
                        :prop="`formData.${index}.rules.${$i}.ruleContent`"
                        :rules="{
                          required: true,
                          message: '内容不能为空',
                          trigger: 'change'
                        }"
                      >
                        <el-input
                          clearable
                          v-model="val.ruleContent"
                          placeholder="若内容存在多个，则用'、'进行隔开"
                        ></el-input>
                      </el-form-item>

                      <span
                        class="close-opts e6-icon-delete_fill"
                        @click="deleteCurrent(item, $i)"
                      ></span>
                    </template>
                  </div>

                  <el-button
                    v-show="!item.rules.length"
                    type="text"
                    class="add-condition"
                    style="margin-left:0"
                    @click="addItem(item)"
                    >添加条件</el-button
                  >
                </el-form-item>

                <el-button
                  v-show="item.rules.length"
                  type="text"
                  class="add-condition"
                  @click="addItem(item)"
                  >添加条件</el-button
                >
              </el-col>
              <el-col :span="24" v-if="hasSetting">
                <el-form-item
                  label="提醒设置"
                  :prop="`formData.${index}.remindSetJson.value1`"
                  :rules="[
                    {
                      validator: validSetting,
                      trigger: 'change'
                    },
                    {
                      required: true,
                      message: '内容不能为空',
                      trigger: 'change'
                    }
                  ]"
                >
                  <slot name="settings" :item="item">
                    <!--
                     每隔
                    <el-input
                      clearable
                      class="hour-input"
                      v-model="item.remindSetJson.value1"
                    >
                      <template class="suffix_unit" slot="suffix"
                        >小时</template
                      >
                    </el-input>
                    推送车辆实时位置信息(订单开始运输后)
                  -->
                  </slot>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  label="提醒方式"
                  :prop="`formData.${index}.remindModeList`"
                  :rules="{
                    required: true,
                    message: '至少勾选一种提醒方式',
                    trigger: 'change'
                  }"
                >
                  <el-checkbox-group
                    v-model="item.remindModeList"
                    class="check-group"
                  >
                    <el-checkbox
                      v-for="({ id, label }, i) in remindModeList"
                      :key="i"
                      :label="id"
                      >{{ label }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  label="提醒对象"
                  :prop="`formData.${index}.remindPersonList`"
                  :rules="{
                    required: true,
                    message: '至少勾选一种提醒对象',
                    trigger: 'change'
                  }"
                >
                  <slot name="reminder" :item="item">
                    <el-checkbox-group v-model="item.remindPersonList">
                      <template v-if="remindList.includes(1)">
                        <el-checkbox
                          :style="{
                            'margin-right': item.remindPersonList.includes(1)
                              ? 0
                              : '30px'
                          }"
                          :label="1"
                          >联系用户</el-checkbox
                        >
                        <el-form-item
                          v-if="item.remindPersonList.includes(1)"
                          class="cus-form-item"
                          :prop="`formData.${index}.remindUserList`"
                          :rules="{
                            required: true,
                            message: '请选择联系用户',
                            trigger: 'change'
                          }"
                        >
                          <vr-select
                            virtual
                            clearable
                            multiple
                            :is-title="true"
                            class="comparison-operators"
                            v-model="item.remindUserList"
                            :data="contactData.linkManDataSource"
                          ></vr-select>
                        </el-form-item>
                      </template>

                      <el-checkbox v-if="remindList.includes(2)" :label="2"
                        >订单发货人</el-checkbox
                      >
                      <el-checkbox v-if="remindList.includes(3)" :label="3"
                        >订单收货人</el-checkbox
                      >

                      <template v-if="remindList.includes(4)">
                        <el-checkbox
                          :style="{
                            'margin-right': item.remindPersonList.includes(4)
                              ? 0
                              : '30px'
                          }"
                          :label="4"
                          >报警联系人</el-checkbox
                        >

                        <el-form-item
                          v-if="item.remindPersonList.includes(4)"
                          class="cus-form-item"
                          :prop="`formData.${index}.remindAlarmList`"
                          :rules="{
                            required: true,
                            message: '请选择联系人',
                            trigger: 'change'
                          }"
                        >
                          <vr-select
                            virtual
                            clearable
                            multiple
                            :is-title="true"
                            class="comparison-operators"
                            v-model="item.remindAlarmList"
                            :data="contactData.alarmManDataSource"
                          ></vr-select>
                        </el-form-item>
                      </template>

                      <el-checkbox v-if="remindList.includes(5)" :label="5"
                        >司机
                      </el-checkbox>
                      <template v-if="remindList.includes(6)">
                        <el-checkbox :label="6" style="margin-right:0"
                          >承运商</el-checkbox
                        >
                        <el-form-item
                          v-if="item.remindPersonList.includes(6)"
                          class="cus-form-item"
                          :prop="`formData.${index}.remindCarrierList`"
                          :rules="{
                            required: true,
                            message: '请选择承运商',
                            trigger: 'change'
                          }"
                        >
                          <vr-select
                            virtual
                            clearable
                            multiple
                            :is-title="true"
                            class="comparison-operators"
                            v-model="item.remindCarrierList"
                            :data="contactData.carrierIdsPage"
                          ></vr-select>
                        </el-form-item>
                      </template>
                      <el-checkbox v-if="remindList.includes(7)" :label="7"
                        >节点收货人</el-checkbox
                      >
                    </el-checkbox-group>
                  </slot>
                </el-form-item>
              </el-col>
            </template>
          </el-row>
        </div>
        <el-button
          v-if="hasStatus"
          plain
          size="medium"
          class="add-rule e6-icon-add_line"
          @click="addRuleItem"
          >添加新规则</el-button
        >
      </el-form>
    </div>
  </div>
</template>
<script>
import base from "e6-base-carrier-3.0/mixins/base";

export default {
  mixins: [base],
  props: {
    ruleType: {
      Type: String,
      default: "1"
    },
    tabType: {
      Type: String,
      require: true
    },
    title: {
      Type: String,
      default: ""
    },
    subtitle: {
      Type: String,
      default: ""
    },
    hasSetting: {
      Type: Boolean,
      default: true
    },
    validSetting: {
      Type: Function,
      require: true
    },
    remindList: {
      Type: Array | String,
      default: () => [1, 2, 3, 4]
    },
    //联系人下拉列表
    contactData: {
      Type: Array | String,
      default: () => {
        return {
          linkManDataSource: [],
          alarmManDataSource: [], //报警联系人下拉列表
          carrierIdsPage: [], //承运商下拉列表
          ruleConditionList: [],
          ruleWaybillConditionList: []
        };
      }
    }
  },
  data() {
    return {
      remindSetList: [
        {
          id: "eq",
          label: "等于"
        },
        {
          id: "ne",
          label: "不等于"
        },
        {
          id: "ic",
          label: "包含于"
        },
        {
          id: "ni",
          label: "不包含于"
        }
      ],
      remindModeList: [
        {
          id: 1,
          label: "平台提示"
        },
        {
          id: 2,
          label: "短信"
        },
        {
          id: 3,
          label: "邮件"
        },
        {
          id: 4,
          label: "微信（易流云OS）"
        }
      ],

      ruleSetting: {
        formData: [
          {
            id: "", //主键id（修改时传）
            remindModeList: [], //提醒方式集合
            remindPersonList: [], //提醒对象集合
            remindSetJson: {
              //设置特有字段，value1、value2...多个字段一直递增
              value1: ""
            },
            remindUserList: [], //联系用户id集合
            remindAlarmList: [], //报警联系人id集合
            remindCarrierList: [], //承运商id集合
            rules: [
              // {
              //   ruleCondition: "", //规则条件（第一个下拉框）
              //   ruleOperator: "", //规则运算符（第二个下拉框）
              //   ruleContent: "" //规则内容（输入框）
              // }
            ],
            secondClassifyId: this.tabType || (this.ruleType === "1" ? 1 : 101), //业务提醒类型
            statusBoolean: false //状态  true.开  false.关
          }
        ]
      }
    };
  },
  computed: {
    hasStatus() {
      return this.ruleSetting.formData.filter(v => v.statusBoolean).length;
    }
  },
  methods: {
    addRuleItem() {
      let item = {
        id: "", //主键id（修改时传）
        remindModeList: [], //提醒方式集合
        remindPersonList: [], //提醒对象集合
        remindSetJson: {
          //设置特有字段，value1、value2...多个字段一直递增
          value1: ""
        },
        remindUserList: [], //联系用户id集合
        remindAlarmList: [], //报警联系人id集合
        remindCarrierList: [], //承运商id集合
        rules: [
          // {
          //   ruleCondition: "", //规则条件（第一个下拉框）
          //   ruleOperator: "", //规则运算符（第二个下拉框）
          //   ruleContent: "" //规则内容（输入框）
          // }
        ],
        secondClassifyId: this.tabType || (this.ruleType === "1" ? 1 : 101), //业务提醒类型
        statusBoolean: true //状态  true.开  false.关
      };
      this.ruleSetting.formData.push(item);
    },
    addItem({ rules }) {
      if (rules.length) {
        const { /*ruleCondition,*/ ruleOperator, ruleContent } = rules[
          rules.length - 1
        ];
        if (!ruleOperator || !ruleContent) {
          this.$message.info("请补全提醒条件信息");
          // return;
        } else {
          rules.push({
            ruleCondition: "", //规则条件（第一个下拉框）
            ruleOperator: "", //规则运算符（第二个下拉框）
            ruleContent: "" //规则内容（输入框）
          });
        }
      } else {
        rules.push({
          ruleCondition: "", //规则条件（第一个下拉框）
          ruleOperator: "", //规则运算符（第二个下拉框）
          ruleContent: "" //规则内容（输入框）
        });
      }
    },
    deleteCurrent({ rules }, index) {
      rules.splice(index, 1);
    },
    deleteRuleItem(index) {
      this.ruleSetting.formData.splice(index, 1);
    },
    mergeData(data) {
      let item = {
        id: "", //主键id（修改时传）
        remindModeList: [], //提醒方式集合
        remindPersonList: [], //提醒对象集合
        remindSetJson: {
          //设置特有字段，value1、value2...多个字段一直递增
          value1: ""
        },
        remindUserList: [], //联系用户id集合
        remindAlarmList: [], //报警联系人id集合
        remindCarrierList: [], //承运商id集合
        rules: [
          // {
          //   ruleCondition: "", //规则条件（第一个下拉框）
          //   ruleOperator: "", //规则运算符（第二个下拉框）
          //   ruleContent: "" //规则内容（输入框）
          // }
        ],
        secondClassifyId: this.tabType || (this.ruleType === "1" ? 1 : 101), //业务提醒类型
        statusBoolean: false //状态  true.开  false.关
      };
      this.ruleSetting.formData = data.length ? data : [item];
    },
    resetData(data) {
      let item = {
        id: "", //主键id（修改时传）
        remindModeList: [], //提醒方式集合
        remindPersonList: [], //提醒对象集合
        remindSetJson: {
          //设置特有字段，value1、value2...多个字段一直递增
          value1: ""
        },
        remindUserList: [], //联系用户id集合
        remindAlarmList: [], //报警联系人id集合
        remindCarrierList: [], //承运商id集合
        rules: [
          // {
          //   ruleCondition: "", //规则条件（第一个下拉框）
          //   ruleOperator: "", //规则运算符（第二个下拉框）
          //   ruleContent: "" //规则内容（输入框）
          // }
        ],
        secondClassifyId: this.tabType || (this.ruleType === "1" ? 1 : 101), //业务提醒类型
        statusBoolean: false //状态  true.开  false.关
      };
      this.ruleSetting.formData = data.length ? data : [item];
    }
  }
};
</script>
<style lang="scss">
.remind-set {
  height: 100%;
  overflow: auto;
  .edit-title {
    height: auto !important;
    background-color: #fff !important;
    border-color: #fff !important;

    span {
      float: left;
    }
    .title {
      font-size: 14px;
      color: #303133;
      padding-right: 20px;
    }
    .subtitle {
      font-size: 12px;
      color: #868686;
    }
  }
  .edit-content {
    padding: 0 15px;
  }
  .set-content-wrap {
    margin-bottom: 10px;
    .rules-name {
      background-color: #f5f7fa;
      padding: 10px 20px;
      font-size: 14px;
      color: #48494c;
      border-radius: 20px;
      .delete {
        float: right;
        cursor: pointer;
        &:hover {
          color: #46bfea;
        }
      }
    }
    .remind-title {
      display: inline-block;
      width: 70px;
      height: 28px;
      text-align: right;
      line-height: 28px;
      margin-right: 10px;
      font-size: 14px;
    }
    .after-switch {
      font-size: 14px;
      margin-left: 5px;
    }
    .col-item {
      padding-top: 10px;
    }
    .add-condition {
      margin-left: 80px;
      padding-top: 0px;
    }
    .hour-input {
      width: 160px;
    }
    .cus-form-item {
      display: inline-block;
    }
    .check-group {
      height: 28px;
    }
    .form-item-list {
      margin-bottom: 0px;
      .rule-list {
        display: flex;
        &:last-of-type {
          margin-bottom: 0;
        }
      }
      .close-opts {
        margin: 0 20px;
        font-size: 20px;
        color: #c9cfd8;
      }
    }
    .comparison-operators {
      width: 130px;
      margin: 0 10px;
    }
  }
  .add-rule {
    width: 100%;
    border-style: dashed;
    background-color: #f5f7fa;
  }
}
</style>
